<template>
  <div>
    <mdb-modal centered :show="visible">
      <mdb-modal-header class="flex-center" :close="false">
        <h3 class="text-center h3-responsive text-success">Pendaftaran Lapar Berjaya</h3>
      </mdb-modal-header>
      <mdb-modal-body>
          <div class="d-flex flex-center mb-3">
            <img :src="require('@/assets/correct.gif')" style="height: 150px; width: 150px" />
          </div>
          <p class="text-center">Permohonan anda telah diterima untuk diproses. Kami akan proses dalam masa <strong>14</strong> hari.</p>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalBody, mdbModalHeader} from 'mdbvue';

  export default {
    components: {
      mdbModal,
      mdbModalBody, mdbModalHeader
    },
    props: ['visible']
  };
</script>